<div
    class="header"
    [class.mobile]="!isRailOrWider()"
    [class.desktop-collapsed]="isRailOrWider() && !visuallyExpanded()"
>
    <div class="header-content">
        <button
            #navigationToggle
            qpxButton
            matIconButton
            class="menu-toggle text-navigation!"
            [attr.aria-label]="
                isExpanded() ? 'Collapse navigation' : 'Expand navigation'
            "
            [attr.aria-expanded]="isExpanded()"
            aria-controls="application-navigation"
            (click)="toggleNavigation()"
        >
            <ng-icon qpx name="lucidePanelLeft" />
        </button>

        <a
            [routerLink]="['/']"
            class="cursor-pointer home-link"
            [attr.tabindex]="isRailOrWider() && !visuallyExpanded() ? -1 : null"
            [attr.aria-hidden]="
                isRailOrWider() && !visuallyExpanded() ? 'true' : null
            "
        >
            <qpx-logo variant="white" size="sm" />
        </a>
    </div>
</div>
